import { TruckFields } from "./TruckFields";

export const Fields = {
  Truck: TruckFields
};
